import React from 'react';

import styles from './FeedbackPanel.module.scss';
import { FeedbackSlider } from './FeedbackSlider';

export const FeedbackScaleSelector: React.FC<{
	stepLabelMap?: string[];
	value?: number;
	onChange?: (value: number) => void;
}> = ({ stepLabelMap, value, onChange }) => {
	return (
		<FeedbackSlider
			className={styles['scale']}
			value={value}
			stepLabelMap={stepLabelMap}
			onChange={onChange}
		/>
	);
};
